<template>
  <div>
    <routerButton
      v-for="i in 20"
      :key="i"
      :title="title"
      :color="color"
      :height="height"
      :width="width"
      :icon="icon"
    />
  </div>
</template>
<script lang="ts" setup>
import routerButton from "@/components/buttoncard/routerButton.vue";
import { ref } from "vue";
const title = ref("首页");
const color = ref("#00000007");
const height = ref("20");
const width = ref("80");
const icon = ref("图标");
</script>
<style></style>
